export const context = 'containers/IntegratedDownloadCsvPaged'
export const FORMAT_DATE_OF_GENERAL_CSV_DOWNLOAD = 'YYYYMMDD'
export const HEADER_LANGUAGE = 'ja'
